import { SEO } from "@/components/SEO";
import LeadForm from "@/components/marketing/LeadForm";
import { Action } from "@/components/marketing/Marketing";
export default function ContactPage() {
  return (
    <div className="growth">
      <SEO
        title="Tell us what your business needs"
        description="Tell us where you want more customers, better follow-up, or less manual work. Get a scoped starting point with Better Systems AI."
        url="https://www.bettersystems.ai/contact"
      />
      <section className="hero">
        <div className="wrap split" style={{ alignItems: "start" }}>
          <div>
            <span className="eyebrow">Let’s put AI to work</span>
            <h1>
              What would make
              <br />
              <em>business better?</em>
            </h1>
            <p className="intro">
              More customers. Faster follow-up. A team with less on its plate.
              Tell us where you want help, and we’ll figure out a practical
              starting point.
            </p>
            <p className="muted">
              Focused ongoing services start at $500–$1,500/month. Your proposal
              will spell out the work, setup, tools, and any separate costs.
            </p>
            <div className="actions">
              <Action href="/book" secondary>
                Prefer a quick call?
              </Action>
            </div>
            <a className="small" href="mailto:rodolfo@bettersystems.ai">
              rodolfo@bettersystems.ai
            </a>
          </div>
          <div className="formpanel">
            <h3 style={{ marginTop: 0 }}>Tell us about your business.</h3>
            <LeadForm />
          </div>
        </div>
      </section>
    </div>
  );
}
